import { Alert, AlertTitle, Container } from '@mui/material';
import { useTranslator } from 'translation/useTranslator';

export const PermissionDeniedAlert = () => {
  const translator = useTranslator();
  return (
    <Container>
      <Alert severity="error">
        <AlertTitle>{translator.permissionDeniedTitle()}</AlertTitle>
        {translator.permissionDeniedDescription()}
      </Alert>
    </Container>
  );
};
